import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./Attachment.css";
import { LuDownload, LuEye } from "react-icons/lu";
import { IoMdArrowBack } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import {
  downloadAttachment as downloadAttachmentRequest,
  extractFilenameFromHeaders,
  getAttachments,
  viewAttachment as viewAttachmentRequest,
} from "./services/attachmentService";

function Attachment() {
  const [attachmentDetails, setAttachmentDetails] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const viewAttachment = async (fileType) => {
    const previewWindow = window.open("", "_blank");

    try {
      const response = await viewAttachmentRequest(fileType, id);
      const attachmentUrl = URL.createObjectURL(response.data);

      if (previewWindow) {
        previewWindow.location.href = attachmentUrl;
      } else {
        window.open(attachmentUrl, "_blank");
      }

      setTimeout(() => {
        URL.revokeObjectURL(attachmentUrl);
      }, 60000);
    } catch (error) {
      if (previewWindow) {
        previewWindow.close();
      }

      console.error("Error viewing attachment:", error);
    }
  };

  const downloadAttachment = async (fileType) => {
    try {
      const response = await downloadAttachmentRequest(fileType, id);
      const attachmentUrl = URL.createObjectURL(response.data);
      const fallbackName =
        getFileDetails(fileType).fileName !== "NA"
          ? getFileDetails(fileType).fileName
          : `${fileType}-${id}`;

      const link = document.createElement("a");
      link.href = attachmentUrl;
      link.download = extractFilenameFromHeaders(
        response.headers,
        fallbackName
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(attachmentUrl);
      }, 1000);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    }
  };

  useEffect(() => {
    const fetchAttachmentDetails = async () => {
      try {
        const attachments = await getAttachments(id);
        setAttachmentDetails(attachments);
      } catch (error) {
        setAttachmentDetails([]);
        console.error("Error fetching attachment details:", error);
      }
    };

    fetchAttachmentDetails();
  }, [id]);

  const getFileDetails = (documentType) => {
    const attachment = attachmentDetails.find(
      (att) => att.document_type === documentType
    );
    if (attachment) {
      return {
        fileName: attachment.filename,
        fileSize: `${attachment.file_size} KB`,
      };
    } else {
      return {
        fileName: "NA",
        fileSize: "NA",
      };
    }
  };

  const handleBackAttachment = () => {
    const from = location.state?.from;

    if (from?.pathname) {
      navigate(from.pathname, { state: from.state ?? null });
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/datalist");
  };

  const getFileColor = (fileName) => (fileName === "NA" ? "red" : "blue");

  return (
    <div className="attachment">
      <div className="attachment-content">
        <div className="attachments-header">
          <div className="attachments-header-content">
            <Tooltip title="Back" arrow>
              <IoMdArrowBack className="back-attachment" onClick={handleBackAttachment} />
            </Tooltip>
            Attachments
          </div>
        </div>
        <div className="attachments-body">
          {["disposal", "auction", "courtOrder", "handedOver"].map((type) => (
            <div key={type} className="certificates-details">
              <div className="certificates-box1">
                <div className="certificate-detaile-header">
                  {type === "disposal" && "Disposal Order"}
                  {type === "auction" && "Auction Order"}
                  {type === "courtOrder" && "Release on Court Order"}
                  {type === "handedOver" && "Handover Memo"}
                </div>
                <div className="certificate-file-name">
                  File Name:{" "}
                  <span style={{ color: getFileColor(getFileDetails(type).fileName) }}>
                    {getFileDetails(type).fileName}
                  </span>
                </div>
                <div className="certificate-file-name">
                  File Size:{" "}
                  <span style={{ color: getFileColor(getFileDetails(type).fileName) }}>
                    {getFileDetails(type).fileSize}
                  </span>
                </div>
                <div className="button-certificates">
                  <button
                    className="certificate-button-download-view"
                    onClick={() => viewAttachment(type)}
                    disabled={getFileDetails(type).fileName === "NA"}
                    style={{
                      opacity: getFileDetails(type).fileName === "NA" ? 0.5 : 1,
                    }}
                  >
                    <LuEye className="document-download-icon-view" />
                  </button>
                  <button
                    className="certificate-button-download"
                    onClick={() => downloadAttachment(type)}
                    disabled={getFileDetails(type).fileName === "NA"}
                    style={{
                      opacity: getFileDetails(type).fileName === "NA" ? 0.5 : 1,
                    }}
                  >
                    <LuDownload className="document-download-icon" /> Download
                    File
                  </button>
                </div>
                <div className="status-not-uploaded" style={{ color: "green" }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Attachment;
